import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import { translations, detectBrowserLang, SUPPORTED_LANGS } from "./translations";

const I18nContext = createContext(null);

const STORAGE_KEY = "sekai_tensei_lang";

export const I18nProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => {
    if (typeof window === "undefined") return "en";
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (stored && SUPPORTED_LANGS.includes(stored)) return stored;
    } catch (_) { /* ignore */ }
    return detectBrowserLang();
  });

  useEffect(() => {
    if (typeof document !== "undefined") {
      document.documentElement.lang = lang;
    }
  }, [lang]);

  const setLang = (l) => {
    if (!SUPPORTED_LANGS.includes(l)) return;
    setLangState(l);
    try { localStorage.setItem(STORAGE_KEY, l); } catch (_) { /* ignore quota / disabled storage */ }
  };

  const value = useMemo(() => ({
    lang,
    setLang,
    t: translations[lang] || translations.en,
  }), [lang]);

  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
};

export const useI18n = () => {
  const ctx = useContext(I18nContext);
  if (!ctx) throw new Error("useI18n must be used inside I18nProvider");
  return ctx;
};
